module.exports = __webpack_public_path__ + "media/images/flags/1x1/fsm-df45da2a5a3b18cf4dddba828560d4dd.svg";